import script from "./ModalLiqPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalLiqPrice.vue?vue&type=script&setup=true&lang=js"

import "./ModalLiqPrice.vue?vue&type=style&index=0&id=34534219&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34534219"]])

export default __exports__